import { COUNTRY_URL, STATE_URL, DISTRICT_URL, CREATE_ADDRESS_URL, DELETE_ADDRESS_URL} from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const addressApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        countries: builder.query({
            query: () => ({
                url: COUNTRY_URL,
                method: 'GET',
            })
        }),
        states: builder.query({
            query: (country) => ({
                url: `${STATE_URL}?country=${country}`,
                method: 'GET',
            })
        }),
        districts: builder.query({
            query: (state) => ({
                url: `${DISTRICT_URL}?state=${state}`,
                method: 'GET',
            })
        }),
        createAddress : builder.mutation({
            query: ({data, token}) => ({
                url: CREATE_ADDRESS_URL,
                method: 'POST',
                body: data,
                headers: {
                    Authorization: token ? `Bearer ${token}` : '', 
                    },
            }),
        }),
        deleteAddress : builder.mutation({
            query: ({id, token}) => ({
                url: DELETE_ADDRESS_URL,
                method: 'DELETE',
                body: {id},
                headers: {
                    Authorization: token ? `Bearer ${token}` : '', 
                    },
            }),
        }),
    }),
})

export const {
    useCountriesQuery, 
    useStatesQuery, 
    useDistrictsQuery,
    useCreateAddressMutation,
    useDeleteAddressMutation
} = addressApiSlice;